import {
    NOTIFICAIONS_LIST
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case NOTIFICAIONS_LIST:
        return action.payload
      default:
        return state
    }
  }
